<template>
  <div>
    <b-tabs content-class="mt-3" align="center">
      <b-tab title="Payment Exceptions" active>
        <b-row class="mb-1" v-if="paymentExceptions != null">
          <!-- search input -->

          <b-col
            class="d-flex justify-content-end"
            v-if="dataFiltered === true"
          >
            <section v-if="isNotify === 'false'">
              <!-- 
              <button
                class="btn btn-primary"
                v-on:click="resendData"
              > -->
              <button class="btn btn-primary" v-on:click="resendData">
                Resend
              </button>
            </section>

            <section v-else-if="isNotify === 'true'">
              <button class="btn btn-primary" v-on:click="updateTicketFun">
                Update Ticket
              </button>
            </section>
          </b-col>
        </b-row>
        <b-card>
          <!-- search input -->
          <b-row class="mb-1">
            <!-- search input -->
            <b-col>
              <section>
                <b-button
                  v-b-modal.modal-filter-paymentexceptions
                  variant="outline-primary"
                  class="d-flex"
                >
                  <feather-icon icon="FilterIcon" />Filter
                </b-button>
              </section>
            </b-col>
            <b-col>
              <b-form-group
                v-if="paymentExceptions.length != 0"
                class="d-flex justify-content-center"
              >
                <!-- search input -->
                <div>
                  <b-form-input
                    v-model="searchTermpayemnt"
                    type="search"
                    placeholder="search"
                  />
                </div>
              </b-form-group>
            </b-col>

            <b-col
              v-if="sheets[0].data.length != 0"
              class="d-flex justify-content-end"
            >
              <xlsx-workbook>
                <xlsx-sheet
                  v-for="sheet in sheets"
                  :key="sheet.name"
                  :collection="sheet.data"
                  :sheet-name="sheet.name"
                />
                <xlsx-download>
                  <b-button variant="primary" class="d-flex">
                    <feather-icon icon="DownloadCloudIcon" /> Export
                  </b-button>
                </xlsx-download>
              </xlsx-workbook>
            </b-col>
          </b-row>

          <div>
            <!-- table -->
            <vue-good-table
              :columns="paymentExceptionsColumns"
              :rows="paymentExceptions"
              :rtl="direction"
              :search-options="{
                enabled: true,
                externalQuery: searchTermpayemnt,
              }"
              :pagination-options="{
                enabled: true,
                perPage: pageLength,
              }"
            >
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                      v-model="pageLength"
                      :options="['5', '10', '15', '30', '50']"
                      class="mx-1"
                      @input="
                        (value) =>
                          props.perPageChanged({ currentPerPage: value })
                      "
                    />
                    <span class="text-nowrap">
                      of {{ props.total }} entries
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="
                        (value) => props.pageChanged({ currentPage: value })
                      "
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>

            <b-row>
              <b-col>
                <b-modal
                  id="modal-filter-paymentexceptions"
                  title="Filter Payment Exception"
                  ok-title="Search"
                  cancel-variant="outline-secondary"
                  size="lg"
                  @ok="filterPaymentException"
                >
                  <b-form>
                    <b-row class="overflow-auto">
                      <b-col cols="8" class="m-auto">
                        <b-form-group
                          label="Merchants option"
                          label-for="Merchants"
                        >
                          <v-select
                            multiple
                            v-model="selected"
                            :options="merchants"
                            label="name"
                          >
                            <template #option="option">
                              <span>{{ option.name }}</span>
                            </template>
                          </v-select>
                        </b-form-group>

                        <b-form-group
                          label="Payment option"
                          label-for="payment-option"
                        >
                          <b-form-select
                            id="merchantId"
                            v-model="filterFopId"
                            :options="paymentOptions"
                          />
                        </b-form-group>

                        <b-form-group label="Paid Date Range">
                          <flat-pickr
                            v-model="trxnDateRange"
                            class="form-control"
                            :config="{ mode: 'range', maxDate: 'today' }"
                          />
                        </b-form-group>

                        <b-form-group
                          label="Is Notified"
                          label-for="is-notified"
                        >
                          <b-form-select
                            id="merchantId"
                            v-model="isNotify"
                            :options="notifyOptions"
                          />
                        </b-form-group>
                        <b-form-group
                          label="Remark Status"
                          label-for="is-notified"
                          v-if="isNotify === 'false'"
                        >
                          <b-form-select
                            id="merchantId"
                            v-model="successStatus"
                            :options="
                              isNotify == 'true'
                                ? remarkStatusTrue
                                : remarkStatusFalse
                            "
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-modal>
              </b-col>
            </b-row>

            <!-- loadings -->
            <b-overlay :show="isLoading" no-wrap rounded="sm" />
          </div>
        </b-card>
      </b-tab>
      <b-tab title="Refund Exceptions">
        <b-col
          class="d-flex justify-content-end"
          v-if="refundExceptions.length > 0"
        >
          <section
            v-if="setRefundException === 0 && setRefundExceptionType === 1"
          >
            <button
              class="btn btn-primary"
              v-on:click="resendDataRefundMerchant"
            >
              Resend
            </button>
          </section>

          <section
            v-else-if="setRefundException === 1 && setRefundExceptionType === 0"
          >
            <button class="btn btn-primary" v-on:click="resendDataRefundBank">
              Resend
            </button>
          </section>
        </b-col>
        <b-card>
          <!-- search input -->
          <b-row class="mb-1">
            <!-- search input -->
            <b-col>
              <section>
                <b-button
                  v-b-modal.modal-filter-refundexceptions
                  variant="outline-primary"
                  class="d-flex"
                >
                  <feather-icon icon="FilterIcon" />Filter
                </b-button>
              </section>
            </b-col>
            <b-col>
              <b-form-group
                v-if="refundExceptions.length != 0"
                class="d-flex justify-content-center"
              >
                <!-- search input -->
                <div>
                  <b-form-input
                    v-model="searchTermrefund"
                    type="search"
                    placeholder="search"
                  />
                </div>
              </b-form-group>
            </b-col>

            <b-col
              v-if="sheets[0].data.length != 0"
              class="d-flex justify-content-end"
            >
              <xlsx-workbook>
                <xlsx-sheet
                  v-for="sheet in sheets"
                  :key="sheet.name"
                  :collection="sheet.data"
                  :sheet-name="sheet.name"
                />
                <xlsx-download>
                  <b-button variant="primary" class="d-flex">
                    <feather-icon icon="DownloadCloudIcon" /> Export
                  </b-button>
                </xlsx-download>
              </xlsx-workbook>
            </b-col>
          </b-row>

          <div>
            <!-- table -->
            <vue-good-table
              :columns="
                this.setRefundException === 0
                  ? this.setRefundExceptionType === 0
                    ? refundExceptionsFaildToInitiate
                    : refundExceptionsNotNotifiedToMerchant
                  : this.setRefundExceptionType === 0
                  ? refundExceptionsNotSentToBank
                  : refundExceptionsRejectedConfirmation
              "
              :rows="refundExceptions"
              :rtl="direction"
              :search-options="{
                enabled: true,
                externalQuery: searchTermrefund,
              }"
              :pagination-options="{
                enabled: true,
                perPage: pageLength,
              }"
            >
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                      v-model="pageLength"
                      :options="['5', '10', '15', '30', '50']"
                      class="mx-1"
                      @input="
                        (value) =>
                          props.perPageChanged({ currentPerPage: value })
                      "
                    />
                    <span class="text-nowrap">
                      of {{ props.total }} entries
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="
                        (value) => props.pageChanged({ currentPage: value })
                      "
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>

            <b-row>
              <b-col>
                <b-modal
                  id="modal-filter-refundexceptions"
                  title="Filter Refund Exception"
                  ok-title="Search"
                  cancel-variant="outline-secondary"
                  size="lg"
                  @ok="filterRefundException"
                >
                  <b-form>
                    <b-row class="overflow-auto">
                      <b-col cols="6">
                        <b-form-group
                          label="Merchants option"
                          label-for="Merchants"
                        >
                          <v-select
                            multiple
                            v-model="selected"
                            :options="merchants"
                            label="name"
                          >
                            <template #option="option">
                              <span>{{ option.name }}</span>
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Refund Exception">
                          <b-form-select
                            id="refund-exception"
                            v-model="setRefundException"
                            :options="refundException"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Refund Exception Type">
                          <b-form-select
                            id="refund-exception-type"
                            v-model="setRefundExceptionType"
                            :options="
                              setRefundException == 0
                                ? merchantRefundExceptionType
                                : bankRefundExceptionType
                            "
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Custom Order Code">
                          <b-form-input
                            id="CustomOrderCode-input"
                            v-model="customOrderCode"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Vendor Txn RefNumber">
                          <b-form-input
                            id="vendorTxnRefNumber-input"
                            v-model="vendorTxnRefNumber"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="FlyGate OrderId">
                          <b-form-input
                            id="flyGateOrderId-input"
                            v-model="flyGateOrderId"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Refund Reference Code">
                          <b-form-input
                            id="refundReferenceCode-input"
                            v-model="refundReferenceCode"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Refund Merchant Request Code">
                          <b-form-input
                            id="refundMerchantRequestCode-input"
                            v-model="refundMerchantRequestCode"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Original Ticket Number">
                          <b-form-input
                            id="OriginalTicketNumber-input"
                            v-model="originalTicketNumber"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Date Range">
                          <flat-pickr
                            v-model="trxnDateRange"
                            class="form-control"
                            :config="{ mode: 'range', maxDate: 'today' }"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-modal>
              </b-col>
            </b-row>

            <!-- loadings -->
            <b-overlay :show="isLoading" no-wrap rounded="sm" />
          </div>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";
import vSelect from "vue-select";
export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    vSelect,
  },
  data() {
    const nowDate = new Date();
    return {
      selected: [],
      merchantIds: "",
      merchants: [],
      isLoading: false,
      dataFiltered: false,
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      setRefundException: 0,
      setRefundExceptionType: 0,
      refundException: [
        {
          value: 0,
          text: "Merchant refund exceptions",
        },
        {
          value: 1,
          text: "Bank refund exceptions",
        },
      ],
      merchantRefundExceptionType: [
        {
          value: 0,
          text: "Failed to initiate",
        },
        {
          value: 1,
          text: "Not notified to Merchant",
        },
      ],
      bankRefundExceptionType: [
        {
          value: 0,
          text: "Not sent to Bank",
        },
        {
          value: 1,
          text: "Rejected Confirmation",
        },
      ],
      orderDateRange: "",
      trxnDateRange: "",
      isNotify: "",
      successStatus: "",
      AllRemark: "",
      searchTermpayemnt: "",
      searchTermrefund: "",
      orderStartDate: "",
      trxnStartDate: "",
      orderEndDate: "",
      trxnEndDate: "",
      filterFopId: 0,
      customOrderCode: "",
      vendorTxnRefNumber: "",
      flyGateOrderId: "",
      refundReferenceCode: "",
      refundMerchantRequestCode: "",
      fromRefundRequestedDate: "",
      toRefundRequestedDate: "",
      originalTicketNumber: "",
      paymentExceptionsColumns: [
        {
          label: "Merchant Name",
          field: "merchantName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Order ID",
          field: "orderId",
        },
        {
          label: "Order Date",
          field: "orderDateString",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Payment Option",
          field: "paymentOptionName",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Paid Date",
          field: "paidDateString",
        },
        {
          label: "Expiry Date",
          field: "expiryDateString",
        },
        {
          label: "Paid PaymentOption",
          field: "paidPaymentOptionName",
        },
        {
          label: "Vendor Txn RefNumber",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Is Notify",
          field: "isNotify",
        },
        {
          label: "Notify Remark",
          field: "notifyRemark",
        },
      ],
      refundExceptionsFaildToInitiate: [
        {
          label: "Date",
          field: "refundRequestedDate",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Fly Gate OrderId",
          field: "flyGateOrderId",
        },
        {
          label: "Paid FOP",
          field: "paidFOP",
        },
        {
          label: "Vendor TxnRef. Number",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },

        {
          label: "Refund Requested Amount",
          field: "refundableAmount",
        },
        {
          label: "Original TicketNumber",
          field: "originalTicketNumber",
        },
        {
          label: "Response message",
          field: "errorMessage",
        },
      ],
      refundExceptionsNotNotifiedToMerchant: [
        {
          label: "Date",
          field: "refundRequestedDate",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Fly Gate OrderId",
          field: "flyGateOrderId",
        },
        {
          label: "Refund FOP",
          field: "refundFOP",
        },
        {
          label: "Bank Refund Reference",
          field: "bankRefundReference",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },
        {
          label: "Refund Reference Code",
          field: "refundReferenceCode",
        },
        {
          label: "Refund Requested Amount",
          field: "refundRequestedAmount",
        },
        {
          label: "Response message",
          field: "notifyRemark",
        },
      ],
      refundExceptionsNotSentToBank: [
        {
          label: "Date",
          field: "refundRejectedDate",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Fly Gate OrderId",
          field: "flyGateOrderId",
        },
        {
          label: "Refund FOP",
          field: "refundFOP",
        },
        {
          label: "Vendor TxnRef. Number",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },
        {
          label: "Refund Reference Code",
          field: "refundReferenceCode",
        },
        {
          label: "Refund Requested Amount",
          field: "refundRequestedAmount",
        },
        {
          label: "Response message",
          field: "banknotifyremark",
        },
      ],
      refundExceptionsRejectedConfirmation: [
        {
          label: "Date",
          field: "refundRejectedDate",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Fly Gate OrderId",
          field: "flyGateOrderId",
        },
        {
          label: "Refund FOP",
          field: "refundFOP",
        },
        {
          label: "Bank Refund Reference",
          field: "bankRefundReference",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },
        {
          label: "Refund Reference Code",
          field: "refundReferenceCode",
        },
        {
          label: "Refund Requested Amount",
          field: "refundRequestedAmount",
        },
        {
          label: "Response message",
          field: "refundremark",
        },
      ],
      paymentOptions: [{ value: 0, text: "--select Payment Option--" }],
      notifyOptions: [
        { value: "true", text: "True" },
        { value: "false", text: "False" },
      ],
      remarkStatusTrue: [
        { value: "true", text: "Success" },
        { value: "false", text: "Failed" },
      ],
      remarkStatusFalse: [
        { value: "true", text: "With Remark" },
        { value: "false", text: "Null remarks" },
      ],
      paymentExceptions: [],
      refundExceptions: [],
      ordersId: [],
      refundIds: [],
      sheets: [{ name: "Detail Transactions", data: [] }],
      url: "",
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchMerchant();
    this.fetchallPaymentOptions();
  },
  beforeCreate() {
    this.$http.get("/account-setting/data").then((res) => {
      this.options = res.data;
    });
  },
  methods: {
    fetchMerchant() {
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          this.merchants = res.merchants;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    fetchallPaymentOptions() {
      this.isLoading = true;
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterRefundException() {
      this.selected.map((m) => {
        this.merchantIds += m.id + ",";
      });
      this.merchantIds = this.merchantIds.slice(0, -1);
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      // Api call
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Report-RefundExceptionReport"
      );

      this.setRefundException === 0
        ? this.setRefundExceptionType === 0
          ? (this.url = `/Order/api/V1.0/Refund/FilterRefundExceptionsFromMerchants?CustomOrderCode=${this.customOrderCode}&ReferenceNumber=${this.vendorTxnRefNumber}&FlyGateOrderId=${this.flyGateOrderId}&RefundReferenceCode=${this.refundReferenceCode}&RefundMerchantRequestCode=${this.refundMerchantRequestCode}&FromRefundRequestedDate=${this.trxnStartDate}&ToRefundRequestedDate=${this.trxnEndDate}&OriginalTicketNumber=${this.originalTicketNumber}&MerchantIDs=${this.merchantIds}`)
          : (this.url = `/Order/api/V1.0/Refund/FilterFailedRefundConfirmation?CustomOrderCode=${this.customOrderCode}&ReferenceNumber=${this.vendorTxnRefNumber}&FlyGateOrderId=${this.flyGateOrderId}&RefundReferenceCode=${this.refundReferenceCode}&RefundMerchantRequestCode=${this.refundMerchantRequestCode}&FromRefundedDate=${this.trxnStartDate}&ToRefundedDate=${this.trxnEndDate}&OriginalTicketNumber=${this.originalTicketNumber}&MerchantIDs=${this.merchantIds}`)
        : this.setRefundExceptionType === 0
        ? (this.url = `/Order/api/V1.0/Refund/FilterRejectedRefundRequestsbytheBank?CustomOrderCode=${this.customOrderCode}&vendorTxnRefNumber=${this.vendorTxnRefNumber}&flyGateOrderId=${this.flyGateOrderId}&refundReferenceCode=${this.refundReferenceCode}&refundMerchantRequestCode=${this.refundMerchantRequestCode}&fromRefundRequestedDate=${this.trxnStartDate}&toRefundRequestedDate=${this.trxnEndDate}&MerchantIDs=${this.merchantIds}`)
        : (this.url = `/Order/api/V1.0/Refund/FilterFailedRefundConfirmationFromBanks?CustomOrderCode=${this.customOrderCode}&vendorTxnRefNumber=${this.vendorTxnRefNumber}&flyGateOrderId=${this.flyGateOrderId}&refundReferenceCode=${this.refundReferenceCode}&refundMerchantRequestCode=${this.refundMerchantRequestCode}&fromRefundRequestedDate=${this.trxnStartDate}&toRefundRequestedDate=${this.trxnEndDate}&MerchantIDs=${this.merchantIds}`);

      axios
        .get(this.url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;

          this.setRefundException == 0
            ? this.setRefundExceptionType === 0
              ? (this.refundExceptions = res.refundExceptions)
              : ((this.refundExceptions = res.failedRefundConfirmation),
                (this.refundIds = []),
                res.failedRefundConfirmation.forEach((order) => {
                  this.refundIds.push(order.id);
                }))
            : this.setRefundExceptionType === 0
            ? ((this.refundExceptions = res.rejectedRequestes),
              (this.refundIds = []),
              res.rejectedRequestes.forEach((order) => {
                this.refundIds.push(order.refundReferenceCode);
              }))
            : (this.refundExceptions = res.failedRefundConfirmationFromBank);

          this.setRefundException == 0 && this.setRefundExceptionType === 0
            ? this.refundExceptions.map((m) => {
                const paidFOp = this.paymentOptions.filter(
                  (f) => m.paidFOP == f.value
                );
                m.paidFOP = paidFOp[0] ? paidFOp[0].text : null;
              })
            : this.refundExceptions.map((m) => {
                const paidFOp = this.paymentOptions.filter(
                  (f) => m.refundFOP == f.value
                );
                m.refundFOP = paidFOp[0] ? paidFOp[0].text : null;
              });

          this.setRefundException == 0
            ? this.setRefundExceptionType === 0
              ? this.refundExceptions.map((m) => {
                  this.sheets[0].data.push({
                    Date: m.refundRequestedDate,
                    "First Name": m.firstName,
                    "Last Name": m.lastName,
                    "Custom Order Code": m.customOrderCode,
                    "Fly Gate OrderId": m.flyGateOrderId,
                    "Paid FOP": m.paidFOP,
                    "Vendor TxnRef. Number": m.vendorTxnRefNumber,
                    "Refund Merchant Request Code": m.refundMerchantRequestCode,
                    "Refund Requested Amount": m.refundableAmount,
                    "Original TicketNumber": m.originalTicketNumber,
                    "Response message": m.errorMessage,
                  });
                })
              : this.refundExceptions.map((m) => {
                  this.sheets[0].data.push({
                    Date: m.refundRequestedDate,
                    "First Name": m.firstName,
                    "Last Name": m.lastName,
                    "Custom Order Code": m.customOrderCode,
                    "Fly Gate OrderId": m.flyGateOrderId,
                    "Refund FOP": m.refundFOP,
                    "Bank Refund Reference": m.bankRefundReference,
                    "Refund Reference Code": m.refundReferenceCode,
                    "Refund Merchant Request Code": m.refundMerchantRequestCode,
                    "Refund Requested Amount": m.refundRequestedAmount,
                    "Response message": m.notifyRemark,
                  });
                })
            : this.setRefundExceptionType === 0
            ? this.refundExceptions.map((m) => {
                this.sheets[0].data.push({
                  Date: m.refundRejectedDate,
                  "First Name": m.firstName,
                  "Last Name": m.lastName,
                  "Custom Order Code": m.customOrderCode,
                  "FlyGate OrderId": m.flyGateOrderId,
                  "Refund FOP": m.refundFOP,
                  "Vendor Txn RefNumber": m.bankRefundReference,
                  "Refund Reference Code": m.refundReferenceCode,
                  "Refund Merchant Request Code": m.refundMerchantRequestCode,
                  "Refundable Amount": m.refundRequestedAmount,
                  "Response Message": m.banknotifyremark,
                });
              })
            : this.refundExceptions.map((m) => {
                this.sheets[0].data.push({
                  Date: m.refundRejectedDate,
                  "First Name": m.firstName,
                  "Last Name": m.lastName,
                  "Custom Order Code": m.customOrderCode,
                  "FlyGate OrderId": m.flyGateOrderId,
                  "Refund FOP": m.refundFOP,
                  "Bank Refund Reference": m.bankRefundReference,
                  "Refund Merchant Request Code": m.refundMerchantRequestCode,
                  "Refund Reference Code": m.refundReferenceCode,
                  "Refundable Amount": m.refundRequestedAmount,
                  "Response Message": m.refundremark,
                });
              });

          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
          this.merchantIds = "";
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
          this.refundExceptions = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
          this.merchantIds = "";
        });
    },
    filterPaymentException() {
      this.selected.map((m) => {
        this.merchantIds += m.id + ",";
      });
      this.merchantIds = this.merchantIds.slice(0, -1);
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }
      if (this.isNotify === "true") {
        (this.successStatus = "false"), (this.AllRemark = "false");
      } else {
        if (this.successStatus === "") {
          (this.successStatus = "false"),
            (this.isNotify = "false"),
            (this.AllRemark = "true");
        } else if (this.successStatus === "true") {
          (this.successStatus = "true"), (this.AllRemark = "false");
          this.isNotify = "false";
        } else {
          (this.successStatus = "false"), (this.AllRemark = "false");
          this.isNotify = "false";
        }
      }
      // Api call
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Report-PaymentExceptionReport"
      );
      const url = `/Order/api/V1.0/Report/GetTransactionSuccessErrorReport?transactionStartDate=${this.trxnStartDate}&transactionEndDate=${this.trxnEndDate}&paymentOptionId=${this.filterFopId}&isNotify=${this.isNotify}&remarkStatus=${this.successStatus}&merchantIds=${this.merchantIds}&AllRemark=${this.AllRemark}`;

      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];

          this.ordersId = [];
          res.orders.forEach((order) => {
            this.ordersId.push(order.id);
          });

          this.dataFiltered = true;

          this.paymentExceptions = res.orders;
          res.orders.map((m) => {
            this.sheets[0].data.push({
              "Merchant Name": m.merchantName,
              "Custom OrderCode": m.customOrderCode,
              "Order Id": m.orderId,
              "Order Date": m.orderDateString,
              "First Name": m.firstName,
              "Last Name": m.lastName,
              "Payment Option": m.paymentOptionName,
              Amount: m.amount,
              "Paid Date": m.paidDateString,
              "Expiry Date": m.expiryDateString,
              "Paid Payment Option": m.paidPaymentOptionName,
              "vendor Txn RefNumber": m.vendorTxnRefNumber,
              isNotify: m.isNotify,
              "Notify Remark": m.notifyRemark,
            });
          });
          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
          this.merchantIds = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.paymentExceptions = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
          this.merchantIds = "";
        });
    },
    resendData() {
      this.isLoading = true;
      axios
        .post("/Order/api/V1.0/Orders/BulkResendOrder", {
          ordersId: this.ordersId,
        })
        .then((res) => {
          this.$swal({
            icon: "success",
            title: "Orders Resent!",
            text: res.message,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.isLoading = false;
          this.filterPaymentException();
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
    resendDataRefundMerchant() {
      this.isLoading = true;

      axios
        .post(`/Order/api/V1.0/Refund/BulkResendRefundConfirmation`, {
          Ids: this.refundIds,
        })
        .then((res) => {
          this.$swal({
            icon: "success",
            title: "Orders Resent!",
            text: res.message,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
    resendDataRefundBank() {
      this.isLoading = true;
      axios
        .post(`Order/api/V1.0/Refund/BulkResendRefundRequestToBank`, {
          RefundReferenceCode: this.refundIds,
        })
        .then((res) => {
          this.$swal({
            icon: "success",
            title: `${res.message}`,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
    updateTicketFun() {
      this.isLoading = true;
      axios
        .put(
          "/Order/api/V1.0/MerchantServiceNumber/BulkUpdateMerchantServiceNosByOrderId",
          { ordersId: this.ordersId }
        )
        .then((res) => {
          this.$swal({
            icon: "success",
            title: "Ticket Updated!",
            text: res.message,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.isLoading = false;
          this.filterPaymentException();
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
